import React from "react";

import * as Select from "@radix-ui/react-select";
import { useFragment, graphql } from "react-relay";
import { WorkspaceSelector_workspaces$key } from "./__generated__/WorkspaceSelector_workspaces.graphql";
import { WorkspaceSelectorContent } from "./WorkspaceSelectorContent";
import { SelectorValueTrigger } from "../OrgAdmin/OrgUsers/Selector";

export function WorkspaceSelector(props: {
  workspaces: WorkspaceSelector_workspaces$key;
  onSelectWorkspace: (workspaceId: string) => void;
  workspaceId: string;
  disabledIds?: string[];
  mode?: "compact" | "large";
}) {
  const workspaces = useFragment(
    graphql`
      fragment WorkspaceSelector_workspaces on Workspace @relay(plural: true) {
        id
        name
        parentId
        ...WorkspaceSelectorContent_workspaces
      }
    `,
    props.workspaces
  );
  const value = props.workspaceId;

  const selectedWorkspace = workspaces.find((v) => v.id === value);

  return (
    <Select.Root
      value={value}
      onValueChange={(v) => {
        props.onSelectWorkspace(v);
      }}
    >
      <SelectorValueTrigger
        valueLabel={selectedWorkspace?.name ?? ""}
        textType="title"
        mode={props.mode ?? "compact"}
      />
      <Select.Portal>
        <WorkspaceSelectorContent
          selectedId={selectedWorkspace?.id}
          workspaces={workspaces}
          disabledIds={props.disabledIds}
        />
      </Select.Portal>
    </Select.Root>
  );
}
